import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject } from '@ember/service';
import { task, timeout } from 'ember-concurrency';
import { beebeeAjaxGet, notifyUserError } from 'beebee-base/lib/utility';
import getConfig from 'beebee-base/lib/get-config';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div ...attributes {{did-insert this.loadData}} {{did-update this.loadData @item @item.id}}>\n  {{#each this.contactStates as |state|}}\n    <BbField @label={{concat-string state.item_number state.status_name}}>\n      <HasMany\n        @item={{@item}}\n        @applicationController={{@applicationController}}\n        @relatedHasMany={{this.relatedHasMany}}\n        @relatedModelType=\'contact\'\n        @isEditable={{@isEditable}}\n        @status={{state}}\n        @total={{state.item_number}}\n        @saveRelation={{this.saveRelation}}\n        @action={{this.addRelated}}\n        @actionRemove={{this.removeRelated}}\n        data-test-related-contacts-add-related\n        data-test-remove-related\n      />\n    </BbField>\n  {{/each}}\n</div>");

var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
let RelatedContactsComponent = (_dec = task({
  restartable: true
}), _class = class RelatedContactsComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "store", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "notify", _descriptor4, this);
  }
  get saveRelation() {
    return this.args.saveRelation ?? true;
  }
  get relatedContactName() {
    return this.args.relatedContactName ?? 'contacts';
  }
  get contactStates() {
    return this.session.contactStates;
  }
  loadData() {
    const item = this.args.item;
    if (item?.id) {
      this.loadDataTask.perform(item);
    } else {
      this.session.contactStates.forEach(s => {
        if (s.set) s.set('item_number', 0);
      });
    }
  }
  get relatedHasMany() {
    const item = this.args.item;
    return item ? item[this.relatedContactName] : [];
  }
  *loadDataTask(item) {
    yield timeout(100);
    const modelName = item.constructor.modelName;
    const queryString = `${encodeURIComponent(`${modelName}_id`)}=${encodeURIComponent(item.id)}`;
    try {
      const cs = yield beebeeAjaxGet(`${getConfig(this).APP.urlApi}/item_states?${queryString}`, this.session.token);
      this.store.pushPayload(cs);
    } catch (error) {
      notifyUserError(this.notify, error, this.intl);
    }
  }
  addRelated(id) {
    if (typeof this.args.action === 'function') {
      this.args.action(id);
    }
  }
  removeRelated(id) {
    if (typeof this.args.actionRemove === 'function') {
      this.args.actionRemove(id);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "notify", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "loadData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "loadDataTask", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "loadDataTask"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addRelated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addRelated"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeRelated", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeRelated"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, RelatedContactsComponent);

export { RelatedContactsComponent as default };
//# sourceMappingURL=related-contacts.js.map
